import { lazy, Suspense } from 'react';
import { useLocation } from 'react-router-dom';
import { ErrorBoundary } from './components/ErrorBoundary/ErrorBoundary';

const MainApp = lazy(() => import('./MainApp'));
const EmbedWidget = lazy(() => import('./container/EmbedWidget/EmbedWidget'));

const EMBED_WIDGET_PATH = '/EmbedWidget';

function App() {
    const location = useLocation();
    const isEmbedWidgetRoute = location.pathname === EMBED_WIDGET_PATH;

    if (isEmbedWidgetRoute) {
        return (
            <ErrorBoundary>
                <div className="App">
                    <Suspense fallback={null}>
                        <EmbedWidget />
                    </Suspense>
                </div>
            </ErrorBoundary>
        );
    }

    return (
        <Suspense fallback={null}>
            <MainApp />
        </Suspense>
    );
}

export default App;
